function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Snackbar from '@material-ui/core/Snackbar';
import { children } from '@signal/prop-types';
import ThemeProvider from '@signal/theme/Provider';
import ErrorBoundary from '@signal/components/ErrorBoundary';
import ModalManager from '@signal/components/ModalManager';
import Button from '@signal/components/Button';
import ScrollToTop from '@signal/components/ScrollToTop';
import { isUpdateAvailableSelector, acceptServiceWorkerUpdate, dismissServiceWorkerUpdate } from '../app';
export var SignalProvider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SignalProvider, _PureComponent);

  function SignalProvider() {
    _classCallCheck(this, SignalProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(SignalProvider).apply(this, arguments));
  }

  _createClass(SignalProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          theme = _this$props.theme,
          isUpdateAvailable = _this$props.isUpdateAvailable,
          acceptUpdate = _this$props.acceptUpdate,
          dismissUpdate = _this$props.dismissUpdate;
      return React.createElement(ThemeProvider, {
        theme: theme
      }, React.createElement(ErrorBoundary, null, React.createElement(ModalManager.Provider, null, React.createElement(ModalManager.Root, null), React.createElement(ScrollToTop, null, children), React.createElement(Snackbar, {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        open: isUpdateAvailable,
        ContentProps: {
          'aria-describedby': 'message-id'
        },
        message: React.createElement("span", {
          id: "message-id"
        }, "A new version of Signal is available!"),
        action: React.createElement(Fragment, null, React.createElement(Button, {
          color: "primary",
          size: "small",
          onClick: dismissUpdate
        }, "Skip"), React.createElement(Button, {
          color: "primary",
          size: "small",
          onClick: acceptUpdate
        }, "Update"))
      }))));
    }
  }]);

  return SignalProvider;
}(PureComponent);

_defineProperty(SignalProvider, "propTypes", {
  children: children.isRequired,
  theme: PropTypes.object.isRequired
});

var mapStateToProps = createStructuredSelector({
  isUpdateAvailable: isUpdateAvailableSelector
});
var mapDispatchToProps = {
  acceptUpdate: acceptServiceWorkerUpdate,
  dismissUpdate: dismissServiceWorkerUpdate
};
export default connect(mapStateToProps, mapDispatchToProps)(SignalProvider);